
import { NgModule, Component, Pipe, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import * as lodash from 'lodash';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { MessageComponent } from '../../components/messages/message.component';
import { environment } from '../../../environments/environment';
import { timeout } from 'rxjs/operator/timeout';
import * as countryList from '../../../assets/countries.json';

@Component({ templateUrl: './profile.html', styleUrls: ['./profile.scss'] })
export class ProfileComponent implements OnInit {
  public activeTab: number = 0;
  countries: any = [];
  profileForm: FormGroup;
  firstName: FormControl;
  lastName: FormControl;
  profileImage: FormControl;
  telephone: FormControl;
  promotionalContent: FormControl;
  // Shipping address
  shippingForm: FormGroup;
  companyNameS: FormControl;
  countryS: FormControl;
  streetAddressS: FormControl;
  cityS: FormControl;
  stateS: FormControl;
  zipCodeS: FormControl;
  differentShipping: boolean  = false;
  // Billing address
  billingForm: FormGroup;
  companyName: FormControl;
  country: FormControl;
  streetAddress: FormControl;
  city: FormControl;
  state: FormControl;
  zipCode: FormControl;

  file: any;
  filename: string;
  filetype: string;
  @ViewChild(MessageComponent) public messageComponent: MessageComponent;


  public constructor(
    private http: HttpClient, private router: Router,
    private UserService: UserService) { }

  ngOnInit() {
    this.countries = countryList;
    this.countries = this.countries.map(c => c.name);
    this.createFormControls();
    this.createForm();
    this.loadUserInfo();
  }

  createFormControls() {
    // Profile Form
    this.firstName = new FormControl('', [Validators.required]);
    this.lastName = new FormControl('', [Validators.required]);
    this.telephone = new FormControl('', []);
    this.profileImage = new FormControl('', []);
    this.promotionalContent = new FormControl(false);
    // Billing form
    this.companyName = new FormControl('', [Validators.required]);
    this.country = new FormControl('', [Validators.required]);
    this.streetAddress = new FormControl('', [Validators.required]);
    this.city = new FormControl('', [Validators.required]);
    this.state = new FormControl('', [Validators.required]);
    this.zipCode = new FormControl('', [Validators.required, Validators.pattern("^[0-9]{5,6}(?:-[0-9]{4})?$")]);
    // Shipping form 
    this.companyNameS = new FormControl('', [Validators.required]);
    this.countryS = new FormControl('', [Validators.required]);
    this.streetAddressS = new FormControl('', [Validators.required]);
    this.cityS = new FormControl('', [Validators.required]);
    this.stateS = new FormControl('', [Validators.required]);
    this.zipCodeS = new FormControl('', [Validators.required, Validators.pattern("^[0-9]{5,6}(?:-[0-9]{4})?$")]);
  }

  loadUserInfo() {
    this.UserService.getUserProfile().subscribe(data => {
      this.profileForm.controls.firstName.setValue(data['profile']['name']);
      this.profileForm.controls.lastName.setValue(data['profile']['lastName']);
      this.profileForm.controls.telephone.setValue(data['profile']['phone']);
      this.profileForm.controls.promotionalContent.setValue(data['profile']['consentsPromotionalContent']);
      // billing
      this.companyName.setValue(data['billing']['companyName']);
      this.country.setValue(data['billing']['country']);
      this.streetAddress.setValue(data['billing']['streetAddress']);
      this.city.setValue(data['billing']['city']);
      this.state.setValue(data['billing']['state']);
      this.zipCode.setValue(data['billing']['zipCode']);
      // shipping     
      this.companyNameS.setValue(data['shipping']['companyName']);
      this.countryS.setValue(data['shipping']['country']);
      this.streetAddressS.setValue(data['shipping']['streetAddress']);
      this.cityS.setValue(data['shipping']['city']);
      this.stateS.setValue(data['shipping']['state']);
      this.zipCodeS.setValue(data['shipping']['zipCode']);
      if (this.shippingForm.valid)
        this.differentShipping = true;
    });
  }

  createForm() {
    this.profileForm = new FormGroup({
      firstName: this.firstName,
      lastName: this.lastName,
      telephone: this.telephone,
      profileImage: this.profileImage,
      promotionalContent: this.promotionalContent
    });    
    this.billingForm = new FormGroup({
      companyName: this.companyName,
      country: this.country,
      streetAddress: this.streetAddress,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode
    });
    this.shippingForm = new FormGroup({
      companyNameS: this.companyNameS,
      countryS: this.countryS,
      streetAddressS: this.streetAddressS,
      cityS: this.cityS,
      stateS: this.stateS,
      zipCodeS: this.zipCodeS
    });
   
  }

  validateFileSize(file) {
    if (file.size > 20000000) {
      return false;
    } else {
      return true;
    }
  }

  onDifferentShipping(e) {
    this.companyNameS.setValue('');
    this.countryS.setValue('');
    this.streetAddressS.setValue('');
    this.cityS.setValue('');
    this.stateS.setValue('');
    this.zipCodeS.setValue('');
    this.submitShippingInfo(false);
  }

  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      let originalFile = event.target.files[0];

      reader.readAsDataURL(file);
      reader.onload = () => {
        var validFileTypes = ["image/png", "image/jpg", "image/jpeg"];
        if (!this.validateFileSize(originalFile)) {
          this.profileForm.get("profileImage").setValue("");
          this.profileImage.setErrors({ size: true });
          return;
        } else {
          this.profileImage.setErrors(null);
        }
        if (validFileTypes.indexOf(file.type) == -1) {
          this.profileForm.get("profileImage").setValue("");
          // show message
          this.profileImage.setErrors({ filetype: true });
        } else {
          this.profileImage.setErrors(null);
          try {
            this.filename = file.name;
            this.filetype = this.filetype;
            this.profileForm.get('profileImage').setValue(originalFile)
          } catch (e) {
          }
        }
      };
    }
  }

  private prepareSave(): any {
    let file = this.profileForm.get("profileImage").value;
    const userProfile = {
      profile: {
        name: this.firstName.value,
        lastName: this.lastName.value,
        phone: this.telephone.value,
        consentsPromotionalContent:
          this.profileForm.controls.promotionalContent.value
      }
    };
    let input = new FormData();
    const jsonData = new Blob([JSON.stringify(userProfile)], {
      type: 'application/json',
    });
    input.append('name', this.firstName.value);
    input.append('lastName', this.lastName.value);
    input.append('phone', this.telephone.value);
    input.append(
      'consentsPromotionalContent',
      this.profileForm.controls.promotionalContent.value);
    if (file)
      input.append('profileImage', file);

    return input;
  }

  submitBillingInfo() {
    if (!this.billingForm.valid)
      return;
    const user = {
      billing: {
        companyName: this.companyName.value,
        country: this.country.value,
        streetAddress: this.streetAddress.value,
        city: this.city.value,
        state: this.state.value,
        zipCode: this.zipCode.value,
      }
    };
    this.updateUser(user);
  }

  submitShippingInfo(message?) {
    if (!this.shippingForm.valid && this.differentShipping == true)
      return;
    const user = {
      shipping: {
        companyName: this.companyNameS.value,
        country: this.countryS.value,
        streetAddress: this.streetAddressS.value,
        city: this.cityS.value,
        state: this.stateS.value,
        zipCode: this.zipCodeS.value,
      }
    };
    this.updateUser(user, message);
  }

  private updateUser(user, showMsg?) {
    this.UserService.updateUser(user)
      .subscribe(
        res => {
          if(showMsg !== false)
            this.messageComponent.showSuccess(
              "User information has been updated!");
        },
        err => {
          if (err && err.error && err.error.errors &&
            err.error.errors.length > 0)
            this.messageComponent.showError(err.error.errors[0].message);
          else {
            if (err.status == 413) {
              this.messageComponent.showError(
                "Image selected is too big");
            } else {
              this.messageComponent.showError(err.statusText);
            }
          }
        });
  }

  onSubmit() {
    if (!this.profileForm.valid) return;
    const formModel = this.prepareSave();
    this.updateUser(formModel);
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/profile/profile.ts